import ScalarIconArrowCounterClockwise_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowCounterClockwise.vue.script.js";
//#region src/components/ScalarIconArrowCounterClockwise.vue
var ScalarIconArrowCounterClockwise_default = ScalarIconArrowCounterClockwise_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowCounterClockwise_default as default };

//# sourceMappingURL=ScalarIconArrowCounterClockwise.js.map